import { makeObservable, observable } from "mobx";
import LovService from "../../services/LovService";

export interface Lov {
  id: string;
  name: string;
  code: string;
  group: string;
  value: any;
  updatedDate: number;
}

class LovStore {
  @observable lovGroups: Map<string, Lov[]> = new Map();

  lovService: LovService;

  constructor() {
    makeObservable(this);
    this.lovService = new LovService();
  }

  fetchLovsByName(name: string): Promise<Lov[]> {
    return new Promise((resolve) => {
      this.lovService.getLovsByName(name).then((lovs) => {
        lovs.forEach((lov) => {
          this.lovGroups.set(lov.group, [
            ...(this.lovGroups.get(lov.group) || []),
            lov,
          ]);
        });
        resolve(lovs);
      });
    });
  }

  fetchLovsByGroup(group: string): Promise<Lov[]> {
    return new Promise((resolve) => {
      if (this.lovGroups.has(group)) {
        resolve(this.lovGroups.get(group) || []);
      } else {
        this.lovService.getLovsByGroup(group).then((lovs) => {
          this.lovGroups.set(group, lovs);
          resolve(lovs);
        });
      }
    });
  }

  fetchLovByCode(
    code: string,
    group: string,
    useCache = true
  ): Promise<Lov | null> {
    return new Promise((resolve) => {
      const lovs = this.lovGroups.get(group);
      const found = lovs?.find((lov) => lov.code === code);

      if (found && useCache) {
        resolve(found);
      } else {
        this.lovService.getLovByCodeAndGroup(code, group).then((lov) => {
          if (lov) {
            this.lovGroups.set(group, [
              ...(this.lovGroups.get(group) || []),
              lov,
            ]);
          }
          resolve(lov);
        });
      }
    });
  }

  updateLov(id: string, lov: Lov): Promise<Lov> {
    return this.lovService.updateLov(id, lov);
  }
}

export default LovStore;
